export default __webpack_public_path__ + "static/lalibrairie-j-desktop-012e67e7c2c43c90859777e577d902ea.jpg";